<script>
import Main from './main.vue';

export default Main.extend({
  methods: {
    getData() {
      return new Promise((res) => {
        // Seed data
        const output = [
          {
            name: 'QA model(s)',
            data: [{
              x: 0,
              y: 1,
              data: 1,
            }],
          },
        ];
        res(output);
      });
    },
  },
});
</script>
